import React, { FC } from 'react';
import { CustomIcon } from './label-icon';
import { stylesheet } from 'typestyle';
import swanIcon from '@src/images/icons/swan-logo.svg';

import { getLabelColor } from './label-color';
import { Label } from './types';

type LabelPreviewProps = {
  label: Label;
  columns: [number, number];
  isValid: boolean;
};

// TODO: Well, this is a default label color when enable_high_contrast flag is disabled
// Would be great to synchronize the look and feel as this may not exactly match the widget
const DEFAULT_LABEL_PREVIEW_COLOR = '#949494';

export const LabelPreview: FC<LabelPreviewProps> = ({ columns, label, isValid }) => (
  <div className="ant-row ant-form-item">
    <div className={`ant-col ant-col-${columns[0]} ant-form-item-label`}>
      <label className="ant-form-item-no-colon">Label Preview</label>
    </div>
    <div className={`ant-col ant-col-${columns[1]} ant-form-item-control`}>
      <div className="ant-form-item-control-input">
        {isValid && (
          <div className={styles.wrapper}>
            <PreviewIcon label={label} />
            <span
              style={{ color: getLabelColor(label) || DEFAULT_LABEL_PREVIEW_COLOR }}
              className={styles.label}
            >
              {label.name}
            </span>
          </div>
        )}
      </div>
    </div>
  </div>
);

const PreviewIcon: FC<{ label: Label }> = ({ label }) => {
  if (label.type === 'LABEL_TYPE_SWAN') {
    return (
      <img aria-hidden="true" src={swanIcon} width="16px" height="16px" className={styles.icon} />
    );
  }

  if (!label.icon) {
    return null;
  }

  return (
    <CustomIcon
      aria-hidden="true"
      color={getLabelColor(label) || DEFAULT_LABEL_PREVIEW_COLOR}
      name={label.icon}
      className={styles.icon}
    />
  );
};

const styles = stylesheet({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '4px',
  },
  label: {
    fontSize: '12px',
    lineHeight: '16px',
  },
});
